import {
  SET_REGIONS,
  SET_USERS_DS,
} from '../constants/ActionTypes'

const initialState = {
  regions: [],
  users_ds: []
}

export default function dictionary(state = initialState, action) {
  switch (action.type) {
    case SET_REGIONS:
      return { ...state, regions: action.items }
    case SET_USERS_DS:
      return { ...state, users_ds: action.users }
    default:
      return state
  }
}
